import type { HttpPort } from "~/lib/http";

export interface Classmate {
  student_id: string;
  monster_name: string | null;
  level: number | null;
  morning_mood: number | null;
}

export interface MyClassSnapshot {
  classmates: Classmate[];
  selfId: string;
}

export function createStudentMyClassModule(http: HttpPort, token: string) {
  return {
    async load(classId: string): Promise<MyClassSnapshot> {
      return http.request<MyClassSnapshot>({ path: `/students/${classId}/classmates`, token });
    }
  };
}

export type StudentMyClassModule = ReturnType<typeof createStudentMyClassModule>;
